import { useState } from "react";
import { IEditClientColorProps } from "./EditClientColor.props";
import useApiRequests from "@services/http/useApiRequest";
import { EditUserColor } from "@services/rackService";
import { useDispatch } from "react-redux";
import { editUserColor } from "@store/users/actions";
import { makeNotifs } from "@utils/makeNotifs";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

export enum CLIENT_COLORS {
  YELLOW = "#FFF500",
  PURPLE = "#D8A7FF",
  GREEN = "#BAF213",
}

interface IEditClientColorControl {
  readonly color: string;

  onChooseColor(color: string): void;
  onSave(): void;
}

export const useEditClientColorControl = (
  props: IEditClientColorProps
): IEditClientColorControl => {
  const dispatch = useDispatch();
  const { enqueue } = useApiRequests();
  const { ok } = makeNotifs();
  const { onSuccess } = useGlobalNotifs();
  const [color, setColor] = useState<string>(props.client.color);

  const onChooseColor = (c: string) => setColor(c);

  const onSave = async () => {
    const res = enqueue(new EditUserColor(props.client.id, color));

    if (!res) return;
    dispatch(editUserColor({ ...props.client, color }));
    onSuccess(ok.success);
    props.handleDestroy();
  };

  return {
    color,

    onChooseColor,
    onSave,
  };
};
